/**
 * Local HQ message catalog used by mission procedures.
 *
 * Values are passed directly to injectHQMessage() and related HQ panel builders.
 */
const LOCAL_HQ_MESSAGES = {
 _global: {
  HQmessage_probabFeedback: {
   portrait: "hq-impressed",
   text: "The mafias have new car assignments and place packages in random lanes to confuse you.",
   continueKey: "Space",
  },
  HQmessage_reminderSpeed: {
   portrait: "hq-impressed",
   text: "Reminder: You can tap the  ‘{{Slash}}’ key to speed up and catch cars and packages faster.",
   highlights: [
    { text: "Reminder:" },
    { conditional: { key: "Slash" } },
    { text: "speed up" },
    { text: "‘" },
    { text: "’" },

   ],
   continueKey: "Space",
  },
  HQmessage_ruleSwitch: {
   portrait: "hq-impressed",
   text: "The mafias swapped their cars. Figure out the new way cars are assigned to each mafia. Note: Mafias can change their assignments at any time.",
   highlights: [
    { text: "swapped" },
    { text: "new way cars are assigned" },
   ],
   continueKey: "Space",
  },
  HQmessage_SpeedUpPackage: {
   portrait: "hq-impressed",
   text: "Reminder: When in a lane, you can tap the  ‘{{Slash}}’ key to speed up and reach packages faster.",
   highlights: [
    { text: "Reminder:" },
    { conditional: { key: "Slash" } },
    { text: "reach packages faster" },
    { text: "‘" },
    { text: "’" },
   ],
   continueKey: "Space",
  },
  HQmessage_stimMappingChange: {
   portrait: "hq-impressed",
   text: "Mission Update: Code keys changed! Figure out which code signal (dark, odd, etc.) corresponds to which lane!",
   highlights: [{ text: "Mission Update:" }],
   continueKey: "Space",
  },
 },
 0: {
  HQmessageM0_practiceEnd: {
   portrait: "hq-impressed",
   text: "Practice is over! /n Now, it's your turn to crack the codes. Ready?",
   continueKey: "Space",
  },
 },
 1: {
  HQmessageM1m0_introKeys: {
   portrait: "hq-impressed",
   text: "First, familiarize yourself with the controls: Move into the lane that matches the displayed category.",
   continueKey: "Space",
  },
  HQmessageM1m0_targetLocking: {
   portrait: "hq-impressed",
   text: "The first thing to do: When you're near the front target, press the spacebar to latch onto it.",
   highlights: [{ text: "first thing to do:" }],
   continueKey: "Space",
  },
  HQmessageM1m1_reminderSpacebar: {
   portrait: "hq-impressed",
   text: "Reminder: Press {{Space}} to latch onto targets. Adjust speed by slowing down/speeding up.",
   highlights: [
    { text: "Reminder:" },
    { conditional: { key: "Space" } },
    { text: "latch" },
    { text: "targets" },
   ],
   continueKey: "Space",
  },
  HQmessageM1m2_practiceStart: {
   portrait: "hq-impressed",
   text: "For the next trials, we'll still show the mafia of a car. So, just focus on solving the codes correctly.",
   highlights: [{ text: "show the mafia of a car" }],
   continueKey: "Space",
  },
  HQmessageM1m3_practiceEnd: {
   portrait: "hq-impressed",
   text: "Practice trials ended. Now, you have to figure out the cars' mafia type and solve the codes.",
   continueKey: "Space",
  },
 },
 2: {
  HQmessageM2m0: {
   portrait: "hq-impressed",
   text: "Remember: Speed up to avoid trucks. Press {{Space}} to reject proposals from trucks ahead. Trucks may refuse to move away.",
   highlights: [
    { text: "Remember:" },
    { text: "Speed up" },
    { conditional: { key: "Space" } },
   ],
   continueKey: "Space",
  },
 },
 3: {
  HQmessageM3m0: {
   portrait: "hq-impressed",
   text: "Risk Alert! You will now lose points for mistakes or briefcase bombs. The loss equals the package's value.",
   highlights: [{ text: "Risk Alert!" }],
   continueKey: "Space",
  },
  HQmessageM3m1: {
   portrait: "hq-impressed",
   text: "Risk Alert! You will now lose points only for mistakes (but not for bombs). Loss equals the package's value.",
   highlights: [{ text: "Risk Alert!" }],
   continueKey: "Space",
  },
  HQmessageM3m2: {
   portrait: "hq-impressed",
   text: "New Alert: Even if you crack codes, rewards aren't guaranteed. Packages are sometimes randomly dropped.",
   highlights: [{ text: "New Alert:" }],
   continueKey: "Space",
  },
  HQmessageM3m3: {
   portrait: "hq-impressed",
   text: "I've got insider intel and can flag the bomb briefcases; but I don't know how long I'll have this edge.",
   highlights: [{ text: "insider intel" }],
   continueKey: "Space",
  },
 },
 4: {
  HQmessageM4m0: {
   portrait: "hq-impressed",
   text: "Choose the blue car.",
   highlights: [{ text: "blue" }],
   continueKey: "Space",
  },
  HQmessageM4m1: {
   portrait: "hq-impressed",
   text: "Choose the car that matches the color from the previously seen cars.",
   highlights: [
    { text: "matches" },
    { text: "color" },
   ],
   continueKey: "Space",
  },
  HQmessageM4m2: {
   portrait: "hq-impressed",
   text: "Choose the car that matches the model from the previously seen cars.",
   highlights: [
    { text: "matches" },
    { text: "model" },
   ],
   continueKey: "Space",
  },
 },
 5: {
  HQmessageM5m1: {
   portrait: "hq-impressed",
   text: "Do you want to cooperate? /n For no, press key: {{KeyZ}}. For yes, press key: {{Slash}}",
   showContinueHint: false,
   highlights: [
    { text: "cooperate?" },
    { text: "no" },
    { conditional: { key: "KeyZ" } },
    { text: "yes" },
    { conditional: { key: "Slash" } },
   ],
   continueKey: "Space",
  },
  HQmessageM5m2: {
   variant: "laneChoice",
   portrait: "hq-impressed",
   text: "Choose a lane for partner.",
   showContinueHint: false,
   highlights: [
    { text: "partner" },
    { conditional: { key: "KeyS" } },
    { conditional: { key: "KeyD" } },
    { conditional: { key: "KeyF" } },
    { conditional: { key: "KeyK" } },
    { conditional: { key: "KeyL" } },
    { conditional: { key: "Semicolon" } },
   ],
   laneKeyCodes: ["KeyS", "KeyD", "KeyF", "KeyK", "KeyL", "Semicolon"],
   continueKey: "Space",
  },
  HQmessageM5m3: {
   variant: "laneChoice",
   portrait: "hq-impressed",
   text: "Choose a lane for yourself.",
   showContinueHint: false,
   highlights: [
    { text: "yourself" },
    { conditional: { key: "KeyS" } },
    { conditional: { key: "KeyD" } },
    { conditional: { key: "KeyF" } },
    { conditional: { key: "KeyK" } },
    { conditional: { key: "KeyL" } },
    { conditional: { key: "Semicolon" } },
   ],
   laneKeyCodes: ["KeyS", "KeyD", "KeyF", "KeyK", "KeyL", "Semicolon"],
   continueKey: "Space",
  },
 },
};

function normalizeAgentKey(agentFile) {
 const raw = String(agentFile ?? "")
  .trim()
  .replace(/[?#].*$/, "")
  .replace(/\.svg$/i, "");

 const parts = raw.split(/[\\/]/).filter(Boolean);
 return parts.length ? parts[parts.length - 1] : raw;
}

export function isHQMessageAgentFile(agentFile) {
 const agentKey = normalizeAgentKey(agentFile);
 return agentKey.startsWith("HQmessage");
}

export function buildMissingHQMessageConfig(agentFile) {
 const agentKey = normalizeAgentKey(agentFile);
 return {
  portrait: "hq-impressed",
  text: `Missing HQ message config for ${agentKey}.`,
  continueKey: "Space",
 };
}

/**
 * Returns local HQ message config for a mission/agent pair.
 *
 * @param {number} missionNumber
 * @param {string} agentFile
 * @returns {Object|null}
 */
export function getLocalHQMessageConfig(missionNumber, agentFile) {
 const agentKey = normalizeAgentKey(agentFile);
 const byMission = LOCAL_HQ_MESSAGES[missionNumber];
 if (byMission?.[agentKey]) return byMission[agentKey];

 return LOCAL_HQ_MESSAGES._global?.[agentKey] ?? null;
}

function getHQMessageConfigAcrossMissions(agentFile) {
 const agentKey = normalizeAgentKey(agentFile);
 const missionKeys = Object.keys(LOCAL_HQ_MESSAGES).filter((key) => key !== "_global");
 for (const missionKey of missionKeys) {
  const missionConfig = LOCAL_HQ_MESSAGES[missionKey];
  if (missionConfig?.[agentKey]) return missionConfig[agentKey];
 }
 return null;
}

export function getHQMessagePanelConfig(missionNumber, agentFile) {
 const localConfig = getLocalHQMessageConfig(missionNumber, agentFile);
 if (localConfig) return localConfig;
 const crossMissionConfig = getHQMessageConfigAcrossMissions(agentFile);
 if (crossMissionConfig) return crossMissionConfig;
 if (isHQMessageAgentFile(agentFile)) return buildMissingHQMessageConfig(agentFile);
 return null;
}

export { LOCAL_HQ_MESSAGES };
